import type { Storage } from "../../../utils/backend-types";
import type { FormFieldData } from "../../BuildingBlocks/Forms/Controllers/FormFieldController";

export const BATTERY_STORAGE_FORM_DATA = {
  name: {
    name: "name",
    label: "Bezeichnung",
    type: "text",
    required: true,
    helpText: "Frei wählbar, wird nur zur Identifikation verwendet"
  },
  person: {
    name: "person",
    label: "Unternehmen",
    type: "select", // data will be added in the form because it depends on the siteId
    required: true
  },
  connection: {
    name: "connection",
    label: "Netzverknüpfungspunkt",
    type: "select", // data will be added in the form because it depends on the siteId
    required: true
  },
  commissioning: {
    name: "commissioning",
    label: "Inbetriebnahme",
    type: "date",
    clearable: true
  },
  decommissioning: {
    name: "decommissioning",
    label: "Außerbetriebnahme",
    type: "date",
    clearable: true
  },
  storageSize: {
    name: "storageSize",
    label: "Speicherkapazität (kWh)",
    type: "number",
    required: true,
    min: 0
  },
  installedCapacity: {
    name: "installedCapacity",
    label: "Speicherleistung (kW)",
    type: "number",
    required: true,
    min: 0
  },
  efficiency: {
    name: "efficiency",
    label: "Wirkungsgrad Speicher (%)",
    type: "number",
    helpText:
      "Der Wirkungsgrad eines Lade-Entladezyklus, welcher Verluste im Wechselrichter und den Zellen berücksichtigt. Konstanter Betriebsstrom für Hilfseinrichtungen muss gesondert angegeben werden.",
    min: 0,
    max: 100
  },
  standbyConsumption: {
    name: "standbyConsumption",
    label: "Verbrauch Betriebsstrom (W)",
    type: "number",
    required: true,
    helpText: "Konstanter Verbrauch des Speichers für Hilfseinrichtungen",
    min: 0
  }
} satisfies FormFieldData<Storage>;
